import PartnerApi from '@/api/partner';
import AgreementApi from '@/api/agreement';
import STATUS from '@/constants/status';
import { AGREEMENT_TYPE, AGREEMENT_TYPE_DESC } from '@/constants/agreement';

export default {
  namespaced: true,
  state: {
    id: '',
    mobileNo: '',
    realName: '',
    certification: false,
    isNeedToSignKaSupplementAgreement: false,
    isNeedToSignSubjectChangeAgreement: false,
    isKnownNeedToSignSubjectChangeAgreement: false,
    isNeedToSignRenewCooperationAgreement: false,
    isKnownNeedToSignRenewCooperationAgreement: false,
  },
  getters: {
    id: (state) => state.id,
    isNeedToCheckRenewCooperationAgreement: (state) => !state.isKnownNeedToSignRenewCooperationAgreement && state.isNeedToSignRenewCooperationAgreement,
    isNeedToCheckSubjectChangeAgreement: (state, getters) => !getters.isNeedToCheckRenewCooperationAgreement && !state.isKnownNeedToSignSubjectChangeAgreement && state.isNeedToSignSubjectChangeAgreement,
    isNeedToCheckKaSupplementAgreement: (state) => state.isNeedToSignKaSupplementAgreement,
    agreementOnShowId: (state, getters) => {
      if (getters.isNeedToCheckRenewCooperationAgreement) {
        return AGREEMENT_TYPE.CooperationRenewAgreement;
      } else if (getters.isNeedToCheckSubjectChangeAgreement) {
        return AGREEMENT_TYPE.SubjectChangeAgreement;
      } else if (getters.isNeedToCheckKaSupplementAgreement) {
        return AGREEMENT_TYPE.SupplementalAgreement;
      }
      return -1;
    },
    agreementOnShowDescriptions: (state, getters) => AGREEMENT_TYPE_DESC[getters.agreementOnShowId] || {},
  },
  mutations: {
    setId(state, id) {
      state.id = id;
    },
    setMobileNo(state, mobileNo) {
      state.mobileNo = mobileNo;
    },
    setRealName(state, realName) {
      state.realName = realName;
    },
    setCertification(state, certification) {
      state.certification = certification;
    },
    setIsNeedToSignKaSupplementAgreement(state, isNeedToSign) {
      state.isNeedToSignKaSupplementAgreement = isNeedToSign;
    },
    setIsNeedToSignSubjectChangeAgreement(state, isNeedToSign) {
      state.isNeedToSignSubjectChangeAgreement = isNeedToSign;
    },
    setIsKnownNeedToSignSubjectChangeAgreement(state) {
      state.isKnownNeedToSignSubjectChangeAgreement = true;
    },
    setIsNeedToSignRenewCooperationAgreement(state, isNeedToSign) {
      state.isNeedToSignRenewCooperationAgreement = isNeedToSign;
    },
    setIsKnownNeedToSignRenewCooperationAgreement(state) {
      state.isKnownNeedToSignRenewCooperationAgreement = true;
    },
  },
  actions: {
    async initFromBackend({ commit, dispatch }) {
      try {
        const { respCode, data } = await PartnerApi.queryPartnerInfo() || {};

        if (respCode !== STATUS.SUCCESS) return;

        const {
          partnerId: id, mobile: mobileNo, realName, certification,
        } = data || {};
        commit('setId', id || '');
        commit('setMobileNo', mobileNo || '');
        commit('setRealName', realName || '');
        commit('setCertification', certification || '');
        commit('billModule/setCustomerId', id || '', { root: true });

        await dispatch('checkIsNeedToRenewCooperationAgreement');
      } catch (e) {
        console.log(e);
      }
    },

    async checkIsNeedToRenewCooperationAgreement({ commit, dispatch }) {
      const { data } = await AgreementApi.getRenewCooperationAgreementInfo() || {};
      const {
        required: isNeedToRenewCooperationAgreement,
      } = data || {};

      commit('setIsNeedToSignRenewCooperationAgreement', isNeedToRenewCooperationAgreement);

      if (!isNeedToRenewCooperationAgreement) {
        dispatch('checkIsNeedToChangeSubject');
      }
    },

    async checkIsNeedToChangeSubject({ commit }) {
      const { data } = await AgreementApi.getSubjectChangeInfo() || {};
      const {
        needAdditionalAgreement: isNeedToChangeSubject,
      } = data || {};

      commit('setIsNeedToSignSubjectChangeAgreement', isNeedToChangeSubject);
    },

    checkAgreementNextTime({ commit, getters, dispatch }) {
      switch (getters.agreementOnShowId) {
      case AGREEMENT_TYPE.CooperationRenewAgreement:
        commit('setIsKnownNeedToSignRenewCooperationAgreement');
        dispatch('checkIsNeedToChangeSubject');
        break;
      case AGREEMENT_TYPE.SubjectChangeAgreement:
        commit('setIsKnownNeedToSignSubjectChangeAgreement');
        break;
      case AGREEMENT_TYPE.SupplementalAgreement:
        commit('setIsNeedToSignKaSupplementAgreement', false);
        break;
      default:
        break;
      }
    },

    signAgreementSuccess({ commit, getters }) {
      switch (getters.agreementOnShowId) {
      case AGREEMENT_TYPE.CooperationRenewAgreement:
        commit('setIsKnownNeedToSignRenewCooperationAgreement');
        commit('setIsNeedToSignRenewCooperationAgreement', false);
        break;
      case AGREEMENT_TYPE.SubjectChangeAgreement:
        commit('setIsKnownNeedToSignSubjectChangeAgreement');
        commit('setIsNeedToSignSubjectChangeAgreement', false);
        break;
      case AGREEMENT_TYPE.SupplementalAgreement:
        commit('setIsNeedToSignKaSupplementAgreement', false);
        break;
      default:
        break;
      }
    },
  },
};
